import React, { useState } from "react";
import { api } from "../../lib/api";
import { Loader2, Save } from "lucide-react";

export default function ChangePassword() {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMsg(null);
    if (nw.length < 6) return setMsg({ type: "err", text: "New password must be at least 6 characters" });
    if (nw !== confirm) return setMsg({ type: "err", text: "Passwords do not match" });
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      setMsg({ type: "ok", text: "Password updated successfully!" });
      setCur(""); setNw(""); setConfirm("");
    } catch (e) {
      setMsg({ type: "err", text: e.response?.data?.detail || "Failed" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md">
      <h2 className="font-medium text-gray-800 mb-1">Change Password</h2>
      <p className="text-xs text-gray-500 mb-4">Keep your admin account secure by updating your password regularly.</p>

      <form onSubmit={submit} className="bg-white border rounded-md p-5 space-y-4">
        {msg && (
          <div className={`text-sm p-2 rounded ${msg.type === "ok" ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"}`}>
            {msg.text}
          </div>
        )}
        <Field label="Current Password"><I type="password" value={cur} onChange={setCur} /></Field>
        <Field label="New Password"><I type="password" value={nw} onChange={setNw} /></Field>
        <Field label="Confirm New Password"><I type="password" value={confirm} onChange={setConfirm} /></Field>
        <button disabled={loading} className="w-full bg-[#a08862] hover:bg-[#8e7654] text-white py-2 rounded flex items-center justify-center gap-2">
          {loading ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Update Password
        </button>
      </form>
    </div>
  );
}

const Field = ({ label, children }) => (<div><label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>{children}</div>);
const I = ({ value, onChange, type = "text" }) => (<input type={type} value={value} required onChange={(e) => onChange(e.target.value)} className="w-full border rounded px-3 py-2 text-sm focus:outline-none focus:border-[#a08862]" />);
